import { Card, Descriptions } from "antd";
import { getUser } from "../utils/auth";

export default function Profile() {
  //   const user = JSON.parse(localStorage.getItem("user"));
  const user = getUser();
  return (
    <Card title="My Profile" style={{ maxWidth: 500 }}>
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Name">{user?.name}</Descriptions.Item>

        <Descriptions.Item label="Email">{user?.email}</Descriptions.Item>

        <Descriptions.Item label="Role">{user?.role}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
